const letters = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
]
// length = 26

const findPosition = (position: number, firstLetter = ''): string[] => {
  if (position > letters.length - 1) {
    const fL = !firstLetter ? findPosition((position - (letters.length - 1)) - 1, firstLetter)[1] : firstLetter
    return findPosition((position - (letters.length - 1)) - 1, fL)
  }
  const p = firstLetter + letters[position]
  return [firstLetter, p]
}

export default {
  findPosition
}
